function ArrowLeft({ size = '14', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1.25L6.92929 7.17929C6.96834 7.21834 6.96834 7.28166 6.92929 7.32071L1 13.25"
        stroke="#20293C"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default ArrowLeft;
